module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page bg-fff pb-fixed-btn"
  }, [_c('backTitleBar'), _vm._v(" "), _c('div', {
    staticClass: "pd-030",
    staticStyle: {
      "margin-top": "2rem"
    }
  }, _vm._l((_vm.roleList), function(item) {
    return _c('van-button', {
      key: item.roleId,
      staticStyle: {
        "margin-top": ".3rem"
      },
      attrs: {
        "type": "primary",
        "block": ""
      },
      on: {
        "click": function($event) {
          return _vm.changeRole(item.roleName)
        }
      }
    }, [_vm._v(_vm._s(item.roleName))])
  }), 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-87530b64","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/My/roleList.vue
// module id = uG9j
// module chunks = 51